import avatar from "./img/avatar.png";
import galaxy from "./img/1.jpg";
import wall from "./img/2.jpg";
import logo from "./img/logo.png";
import movie from "./img/mov.png";
import intersteller from "./img/3.jpg";

export const images = {
  avatar,
  galaxy,
  wall,
  intersteller,
  logo,
  movie,
};
